import { useEffect, useState } from "react";
import { Mail, MailX, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export const EmailToggle = () => {
  const [enabled, setEnabled] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings/email").then(({ data }) => setEnabled(!!data.enabled)).catch(() => setEnabled(false));
  }, []);

  const toggle = async () => {
    setSaving(true);
    try {
      const { data } = await api.patch("/settings/email", { enabled: !enabled });
      setEnabled(!!data.enabled);
      toast.success(`Email sending is now ${data.enabled ? "ON" : "OFF"}`);
    } catch (e) {
      toast.error("Failed to update email setting");
    } finally {
      setSaving(false);
    }
  };

  if (enabled === null) return null;

  return (
    <button
      onClick={toggle}
      disabled={saving}
      data-testid="email-toggle"
      title="Toggle whether the system sends emails to customers, references and reps"
      className={`flex items-center gap-2 border px-4 py-3 text-sm transition-colors ${
        enabled
          ? "border-[#10B981] text-[#10B981] hover:bg-[#10B981]/10"
          : "border-zinc-300 text-zinc-500 hover:bg-zinc-100"
      }`}
    >
      {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : enabled ? <Mail className="h-4 w-4" /> : <MailX className="h-4 w-4" />}
      Emails: {enabled ? "ON" : "OFF"}
    </button>
  );
};
